module.exports = __webpack_public_path__ + "static/media/help_1.adf02c53.jpg";